import { EventsManager, GameEvents } from "../../../abstracts/events/EventsManager";
import { AbstractModuleController } from "../../../abstracts/modules/AbstractModuleController";
import { UgliestCatch } from "../../UgliestCatch";
import { UCUserInterfaceView } from "./UCUserInterfaceView";

export class UCUserInterfaceController extends AbstractModuleController {
    public get name(): string {
        return `UCUserInterfaceController`;
    }

    public get view(): UCUserInterfaceView {
        if (this._view === undefined || this._view === null) {
            this._view = new UCUserInterfaceView();
        }
        return this._view as UCUserInterfaceView;
    }

    protected override handleEvents() {
        super.handleEvents();

        EventsManager.on(GameEvents.ON_FREE_BETS_START, () => {
            this.view.disableIdle();
            this.view.onFreeBets();
            EventsManager.trigger(GameEvents.HIDE_XBET_FRAME);
        });

        EventsManager.on(GameEvents.ON_FREE_BETS_END, (isToogled: boolean) => {
            this.view.enableIdle(isToogled);
            if (UgliestCatch.model.isXbet) {
                EventsManager.trigger(GameEvents.SHOW_XBET_FRAME);
            }
        });

        EventsManager.on(GameEvents.ENABLE_IDLE_ANIMATIONS, (isToogled: boolean) => {
            if (isToogled) {
                this.view.enableIdle(isToogled);
            }
        });

        EventsManager.on(GameEvents.DISABLE_IDLE_ANIMATIONS, () => {
            this.view.disableIdle();
        });

        EventsManager.on(GameEvents.ON_XWAYS_BUTTON_CLICK, (isToggled: boolean) => {
            this.view.onXBetBtnClick(isToggled);
        });

        // EventsManager.on(GameEvents.CHECK_XBET_ON_RESTORE, () => {
        //     this.view.handleRestore();
        // });
    }
}
